__webpack_require__.p = "/flags-game/";